export const LOGO = "https://customer-assets-m6fa6gv7.emergentagent.net/job_9194f03b-d9d8-42bd-8349-c9be831b348f/artifacts/1w6igxuc_95177.png";
export const ADVISOR_WOMAN = "https://customer-assets-m6fa6gv7.emergentagent.net/job_9194f03b-d9d8-42bd-8349-c9be831b348f/artifacts/eh621bwo_97750.png";
export const ADVISOR_MAN = "https://customer-assets-m6fa6gv7.emergentagent.net/job_9194f03b-d9d8-42bd-8349-c9be831b348f/artifacts/88q83bhq_97751.png";
export const ADVISOR_DESK = "https://customer-assets-m6fa6gv7.emergentagent.net/job_9194f03b-d9d8-42bd-8349-c9be831b348f/artifacts/4ydgf4g1_97752.png";
export const ADVISOR_SEATED = "https://customer-assets-m6fa6gv7.emergentagent.net/job_9194f03b-d9d8-42bd-8349-c9be831b348f/artifacts/q486bzap_97753.png";
export const HERO_BG = "https://images.unsplash.com/photo-1771504184695-c2dfceb8e08f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwyfHxnZW5ldmElMjBza3lsaW5lfGVufDB8fHx8MTc4NTg0MjI4OHww&ixlib=rb-4.1.0&q=85";
export const OFFICE_IMG = "https://images.unsplash.com/photo-1604328698692-f76ea9498e76?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHw0fHxmaW5hbmNlJTIwcHJvZmVzc2lvbmFsJTIwb2ZmaWNlfGVufDB8fHx8MTc4NTg0MjI5MHww&ixlib=rb-4.1.0&q=85";
export const DOCS_IMG = "https://images.unsplash.com/photo-1772588627342-5ec373e236d8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHx0YXglMjBkb2N1bWVudHMlMjBkZXNrfGVufDB8fHx8MTc4NTg0MjI4OHww&ixlib=rb-4.1.0&q=85";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const CONTACT_EMAIL = "contact@fiscoconseils.com";

export const PROFILE_LABELS = {
  frontalier: "Frontalier Suisse-France",
  resident: "Résident suisse",
  francaise: "Déclaration française",
  independant: "Indépendant en Suisse",
  entreprise: "Entreprise en Suisse",
};

export const STATUS_LABELS = {
  nouveau: "Nouveau",
  en_cours: "En cours",
  devis_envoye: "Devis envoyé",
  client_signe: "Client signé",
  refuse: "Refusé",
};
